<template>
  <div>
    <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
      <a-divider orientation="left">
        <b>{{ formTitle }}</b>
      </a-divider>
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="手机号" prop="mobile" >
          <a-input v-model="form.mobile" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="邮箱" prop="email" >
          <a-input v-model="form.email" placeholder="请输入邮箱" />
        </a-form-model-item>
        <a-form-model-item label="密码，md5" prop="password" >
          <a-input v-model="form.password" placeholder="请输入密码，md5" />
        </a-form-model-item>
        <a-form-model-item label="头像链接" prop="avatar" >
          <a-input v-model="form.avatar" placeholder="请输入头像链接" />
        </a-form-model-item>
        <a-form-model-item label="昵称" prop="nickname" >
          <a-input v-model="form.nickname" placeholder="请输入昵称" />
        </a-form-model-item>
        <a-form-model-item label="性别,0-保密 1-男 2-女" prop="sex" >
          <a-select placeholder="请选择性别,0-保密 1-男 2-女" v-model="form.sex">
            <a-select-option v-for="(d, index) in sexOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="生日，格式1990-04-22" prop="birthday" >
        </a-form-model-item>
        <a-form-model-item label="用户个性签名" prop="userSign" v-if="formType === 1">
          <a-input v-model="form.userSign" placeholder="请输入用户个性签名" />
        </a-form-model-item>
        <a-form-model-item label="邀请码" prop="invitationCode" >
          <a-input v-model="form.invitationCode" placeholder="请输入邀请码" />
        </a-form-model-item>
<!--      <a-form-model-item label="是否推送 1-是 0-否" prop="isNotice" >-->
<!--        <a-select placeholder="请选择是否推送 1-是 0-否" v-model="form.isNotice">-->
<!--          <a-select-option v-for="(d, index) in isNoticeOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录" prop="status" >
          <a-select placeholder="请选择用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录" v-model="form.status">
            <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark" v-if="formType === 1">
          <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
        </a-form-model-item>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              保存
            </a-button>
            <a-button type="dashed" @click="cancel">
              取消
            </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-drawer>

    <!-- 设置馆长弹窗 -->
    <a-modal
      title="设置馆长"
      :visible="curatorModalVisible"
      @ok="confirmSetCurator"
      @cancel="cancelSetCurator"
      :confirmLoading="curatorLoading"
      width="500px"
      :zIndex="1000"
    >
      <div>
        <div style="margin-bottom: 16px;">
          <span style="display: inline-block; width: 80px; text-align: right; margin-right: 12px;">选择分类：</span>
          <a-select
            v-model="selectedCategoryId"
            placeholder="请选择顶级分类"
            style="width: calc(100% - 100px)"
            allow-clear
          >
            <a-select-option
              v-for="item in topCategoryList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.categoryName }}
            </a-select-option>
          </a-select>
        </div>
        <div style="margin-left: 92px; color: #999; font-size: 12px;">
          提示：只能选择顶级分类，一个用户只能设置一个分类
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getUser, addUser, updateUser } from '@/api/biz/user'
import { listCategory } from '@/api/dynamic/category'

export default {
  name: 'CreateForm',
  props: {
    sexOptions: {
      type: Array,
      required: true
    },
    isNoticeOptions: {
      type: Array,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 设置馆长相关
      curatorModalVisible: false,
      curatorLoading: false,
      selectedCategoryId: null,
      topCategoryList: [], // 顶级分类列表
      currentUserId: null, // 当前设置馆长的用户ID
      // 表单参数
      form: {
        id: null,

        mobile: null,

        email: null,

        password: null,

        avatar: null,

        nickname: null,

        sex: null,

        birthday: null,

        userSign: null,

        invitationCode: null,

        isNotice: null,

        status: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '昵称不能为空', trigger: 'blur' }
        ],

        status: [
          { required: true, message: '用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        mobile: null,
        email: null,
        password: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        userSign: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleWatch(row,num){
      this.reset()
      this.formType = 0
      const id = row.id
      getUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '详细'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    /** 获取顶级分类列表 */
    getTopCategoryList () {
      listCategory().then(response => {
        if (response && response.data) {
          // 过滤出顶级分类（pid为0、null或undefined的）
          this.topCategoryList = response.data.filter(item => {
            const pid = item.pid
            return pid === null || pid == 0
          })
        } else {
          this.topCategoryList = []
        }
      }).catch(err => {
        console.error('获取分类列表失败:', err)
        this.topCategoryList = []
        this.$message.error('获取分类列表失败')
      })
    },

    /** 打开设置馆长弹窗（从父组件调用） */
    handleSetCurator (record) {
      console.log('handleSetCurator 被调用', record)
      console.log('当前 curatorModalVisible:', this.curatorModalVisible)
      if (!record || !record.id) {
        this.$message.error('用户信息不完整')
        return
      }
      this.currentUserId = record.id
      this.selectedCategoryId = record.teenagers || null
      // 先显示弹窗，再加载数据
      this.curatorModalVisible = true
      console.log('设置后 curatorModalVisible:', this.curatorModalVisible)
      this.$nextTick(() => {
        console.log('nextTick 后 curatorModalVisible:', this.curatorModalVisible)
        this.getTopCategoryList()
      })
    },

    /** 确认设置馆长 */
    confirmSetCurator () {
      if (!this.selectedCategoryId) {
        this.selectedCategoryId = 0 // 如果没有选择，默认为顶级分类（即没有馆长）
      }

      this.curatorLoading = true
      updateUser({
        id: this.currentUserId,
        teenagers: this.selectedCategoryId
      }).then(response => {
        this.$message.success('设置馆长成功', 3)
        this.curatorModalVisible = false
        this.$emit('ok')
      }).catch(err => {
        console.error('设置馆长失败:', err)
        this.$message.error('设置馆长失败')
      }).finally(() => {
        this.curatorLoading = false
      })
    },

    /** 取消设置馆长 */
    cancelSetCurator () {
      this.curatorModalVisible = false
      this.selectedCategoryId = null
      this.currentUserId = null
    }
  }
}
</script>
